export const manifestIcon = [
  {
    src: '/assets/favicon/TopFans_57.png',
    sizes: '57x57',
    type: 'image/png'
  },
  {
    src: '/assets/favicon/TopFans_64.png',
    sizes: '64x64',
    type: 'image/png'
  },
  {
    src: '/assets/favicon/TopFans_72.png',
    sizes: '72x72',
    type: 'image/png'
  },
  {
    src: '/assets/favicon/TopFans_114.png',
    sizes: '114x114',
    type: 'image/png'
  },
  {
    src: '/assets/favicon/TopFans_120.png',
    sizes: '120x120',
    type: 'image/png'
  },
  {
    src: '/assets/favicon/TopFans_180.png',
    sizes: '180x180',
    type: 'image/png'
  },
  {
    src: '/assets/favicon/TopFans_192.png',
    sizes: '192x192',
    type: 'image/png'
  },
  {
    src: '/assets/favicon/TopFans_512.png',
    sizes: '512x512',
    type: 'image/png'
  }
];

export const imageSize = {
  144: '144'
};

export const topFanThemeColor = {
 BLUE_THEME : '#013b58',
 MANIFEST_THEME: '#002740',
 MANIFEST_BG: '#013f5e'
};
